import { imgixHost } from 'src/config'
import Model, { encoders, ID, Integer, IsoDateTime } from 'src/models/model'
import SupportCategory from 'src/models/support/SupportCategory'

export default class SupportArticle extends Model {
  static name = 'SupportArticle'

  static duplicatable = true
  static deletable = true
  static versioned = true
  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      title: {
        type: String
      },
      description: {
        type: String
      },
      image: {
        type: String
      },
      supportCategory: {
        type: SupportCategory,
        encode: encoders.hasOne,
        reference: true
      },
      adminRelated: {
        type: Boolean,
        default: true
      },
      posRelated: {
        type: Boolean,
        default: true
      },
      indyOnly: {
        type: Boolean,
        default: false
      },
      displayOrder: {
        type: Integer,
        default: 99999
      },
      published: {
        type: Boolean,
        default: false
      },
      publishedAt: {
        type: IsoDateTime,
        output: true
      },
      type: {
        type: String,
        options: ['Article', 'Video'],
        default: 'Article'
      },
      content: {
        type: String,
        default: ''
      },
      videoType: {
        type: String,
        options: ['Loom', 'YouTube', 'Vimeo'],
        default: 'Loom'
      },
      video: {
        type: String
      }
    }

    this.computed = {
      imageUrl () {
        if (!this.image) return ''

        return `${imgixHost}/${this.image}?w=570&h=354&fit=crop&auto=format,compress`
      },
      videoUrl () {
        if (this.videoType === 'Loom') {
          return `https://www.loom.com/embed/${this.video}`
        } else if (this.videoType === 'Youtube') {
          return `https://www.youtube.com/embed/${this.video}`
        } else if (this.videoType === 'Vimeo') {
          return `https://player.vimeo.com/video/${this.video}`
        }

        // Something went horribly wrong
        return 'https://www.youtube.com/embed/dQw4w9WgXcQ'
      },
      thumbnailUrl () {
        if (this.image) {
          return this.imageUrl
        } else if (this.video) {
          if (this.videoType === 'Loom') {
            return `https://cdn.loom.com/sessions/thumbnails/${this.video}-with-play.jpg`
          } else if (this.videoType === 'Youtube') {
            return `https://img.youtube.com/vi/${this.video}/0.jpg`
          }
        }

        return null
      }
    }
  }
}
